import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import SupportedCoins from '../components/SupportedCoins';
import Features from '../components/Features';
import MarketTable from '../components/MarketTable';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import CTASection from '../components/CTASection';

const Home = () => {
  return (
    <main className="home-page">
      <Hero />
      <SupportedCoins />
      <HowItWorks />
      <Features />
      <MarketTable />
      <Testimonials />
      <FAQ />
      <CTASection />
    </main>
  );
};

export default Home;
